import React, { useState, useEffect } from 'react';
import './styles.scss';

export const FadeBackground = ({ src, alt = 'background' }) => {
  const [images, setImages] = useState({
    primary: src,
    secondary: src,
  });
  const [activeImage, setActiveImage] = useState('primary');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(
    () => {
      if (src && src !== images[activeImage]) {
        setIsLoading(true);

        const img = new Image();

        img.onload = () => {
          const inactiveImage =
            activeImage === 'primary' ? 'secondary' : 'primary';

          setImages(prev => ({
            ...prev,
            [inactiveImage]: src,
          }));

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              setActiveImage(inactiveImage);
              setIsLoading(false);
            });
          });
        };

        img.onerror = () => {
          setIsLoading(false);
        };

        img.src = src;
      }
    },
    [src, images, activeImage],
  );

  return (
    <div className="FadeBackground">
      <img
        className={`FadeBackground__image FadeBackground__image--primary ${
          activeImage === 'primary' ? 'FadeBackground__image--active' : ''
        }`}
        src={images.primary}
        alt={alt}
      />
      <img
        className={`FadeBackground__image FadeBackground__image--secondary ${
          activeImage === 'secondary' ? 'FadeBackground__image--active' : ''
        }`}
        src={images.secondary}
        alt={alt}
      />
      <div className="FadeBackground__overlay" />
    </div>
  );
};

